export const staleTime = 900000;    // 10 mins cache
export const gcTime = 1800000;      // 15 mins delete cache
export const globalSupportEmail = "hello@fourcolorstech.com";